<div class="application-menu-wrapper">
	<div class="menu-header">
		<div class="menu-item-filter">
			<mat-form-field
				class="page-header-menu-filter custom-mat-form-field"
				appearance="outline"
				subscriptSizing="dynamic"
			>
				<mat-label>
					<fa-icon [icon]="$any(['fass', 'filter'])" class="page-header-menu-filter-icon"></fa-icon>
					<span class="page-header-menu-filter-text">Filter</span>
				</mat-label>
				<input
					matInput
					type="text"
					[value]="filterText"
					(input)="filterText = $any($event.target).value"
					(click)="$event.stopPropagation()"
					(keyup)="filterMenu($any($event.target).value)"
				/>
			</mat-form-field>
		</div>

		<div class="menu-buttons" fxLayout="row" fxLayoutAlign="start stretch" role="menubar">
			<button
				mat-menu-item
				[ngClass]="{ selected: getMainMenuMode() == 'home' }"
				fxFlex
				fxLayoutAlign="center center"
				(click)="loadMainMenuItems()"
				[attr.role]="'tab'"
				aria-label="Home"
				matTooltip="Menu Home"
			>
				<fa-icon id="main-menu-action-home" [icon]="$any(['fass', 'home'])" class="menu-icon"></fa-icon>
				<!--<app-db-icon class="menu-icon" [iconId]="795"></app-db-icon>-->
			</button>
			<button
				mat-menu-item
				[ngClass]="{ selected: getMainMenuMode() == 'favorites' }"
				fxFlex
				fxLayoutAlign="center center"
				(click)="loadFavoriteMenuItemsClick()"
				[attr.role]="'tab'"
				aria-label="Favorites"
				matTooltip="Menu Favorites"
			>
				<fa-icon id="main-menu-action-favorites" [icon]="$any(['fass', 'star'])" class="menu-icon"></fa-icon>
			</button>
			<button
				mat-menu-item
				[ngClass]="{ selected: getMainMenuMode() == 'history' }"
				fxFlex
				fxLayoutAlign="center center"
				(click)="loadMenuItemHistoryClick()"
				[attr.role]="'tab'"
				aria-label="History"
				matTooltip="Menu History"
			>
				<fa-icon id="main-menu-action-history" [icon]="$any(['fass', 'history'])" class="menu-icon"></fa-icon>
			</button>
		</div>
	</div>
	<div class="menu-items">
		<!-- Menu Items -->
		<application-menu-menu-items-list
			[nestLevel]="0"
			[paddingPx]="menuPadding"
			[menuConfig]="filteredMenuConfig != null ? filteredMenuConfig : currentMenuTypeConfig"
			[allowLabelToggle]="allowLabelToggle"
			(menuItemClicked)="appMenuItemClicked($event)"
			(menuUpdatedEvent)="menuUpdated()"
		></application-menu-menu-items-list>
	</div>

	<!-- Version -->
	<div
		id="app-menu-version"
		class="version clickable"
		role="button"
		tabindex="0"
		*ngIf="showHeader"
		(click)="showAbout()"
		(keydown.enter)="showAbout()"
		(keydown.space)="showAbout()"
	>
		ver. {{ version }}
	</div>
</div>
